import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import getConfig from "next/config";

import _groupBy from "lodash/groupBy";
import _sortBy from "lodash/sortBy";

import ErrorPage from "@containers/ErrorPage";

import { getBrandsApi, getBrandApi } from "@lib/api/index";
import { apiCall } from "@store/app/actions";
import Link from "next/link";

import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";
import Loading from "@components/Loading";

const {
  publicRuntimeConfig: {
    content: { attributeCodes },
    settings,
  },
} = getConfig();

class BrandsPage extends Component {
  static async getInitialProps(ctx) {
    const { reduxStore } = ctx;

    const brandsResponse = await reduxStore.dispatch(
      apiCall({
        spinner: false,
        alert: true,
        apiCall: getBrandsApi,
        returnResponse: true,
      })
    );

    if (brandsResponse && brandsResponse.ok) {
      const brands = _groupBy(brandsResponse.data, (elem) => {
        const key = elem.name.substring(0, 1);
        if (isNaN(key - parseFloat(key))) {
          return key;
        }
        return "0-9";
      });

      return {
        brands,
      };
    }

    return {
      brands: null,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      activeSlug: null,
      activeBrand: null,
      loadingBrand: false,
    };
  }

  setBrand = async (slug) => {
    this.setState(
      {
        loadingBrand: true,
        activeSlug: slug,
      },
      () => {
        location.hash = "#" + slug;
        const elem = document.getElementById(slug);
        if (elem) {
          elem.scrollIntoView();
        }
      }
    );

    const brandResponse = await this.props.apiCall({
      spinner: false,
      alert: true,
      apiCall: getBrandApi,
      apiArgs: [slug],
      returnResponse: true,
    });

    this.setState({
      activeBrand: brandResponse?.ok ? brandResponse.data : null,
      loadingBrand: false,
    });
  };

  componentDidMount() {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      this.setBrand(hash);
    }
  }

  render() {
    const { brands } = this.props;
    const { activeBrand, loadingBrand, activeSlug } = this.state;

    const titles = brands ? Object.keys(brands).sort() : null;
    if (titles && titles[0] === "0-9") {
      titles.push(titles.shift());
    }

    if (brands) {
      return (
        <>
          <Head>
            <title>Pagina de branduri</title>

            <meta
              name="keywords"
              content="locuri de munca, dezvoltare cariera, job-uri, joburi, pozitii vacante, oportunitati cariera"
            ></meta>
          </Head>

          <Breadcrumbs
            breadcrumbs={[
              {
                id: 1,
                level: 99,
                name: `Branduri`,
              },
            ]}
          />

          <div className="mt-8 mb-2">
            <Heading as="h1" display="h1" title={`Pagina de branduri`} />
          </div>

          <div className="flex flex-wrap">
            {titles.map((title) => (
              <div
                key={title}
                className="block lg:w-1/7 md:w-1/5 sm:w-1/3 w-1/2 pr-4 mt-4"
              >
                <div className="text-red-brand text-6xl pb-4 mb-4 text-normal font-light">
                  {title}
                  <span className="block w-3/5 border-b border-gray-light mt-2"></span>
                </div>
                {_sortBy(brands[title], ["name"]).map((brand) => (
                  <button
                    className="block appearance-none text-left my-1 p-1 rounded"
                    key={brand.id}
                    onClick={() => this.setBrand(brand.slug)}
                  >
                    <span
                      className={`font-normal mr-2 capitalize leading-2 text-sm
                                    ${
                                      activeSlug === brand.slug
                                        ? "text-red-brand"
                                        : "text-black"
                                    }
                                    `}
                    >
                      {" "}
                      {brand.name.toLowerCase()}
                    </span>
                    <span
                      className={`${
                        activeSlug === brand.slug
                          ? "text-red-brand"
                          : "text-gray-light"
                      }`}
                    >
                      ({brand.count})
                    </span>
                    <img
                      src={`${settings.websiteStatics}/images/icons/green-check.png`}
                      alt=""
                      className={`pl-4 align-middle inline-block
                                 ${activeSlug === brand.slug ? "" : "hidden"}
                                `}
                    />
                  </button>
                ))}
              </div>
            ))}
          </div>

          <div id={activeSlug ? activeSlug : ""}>
            {loadingBrand && <Loading height={100} />}

            {activeBrand && !loadingBrand && (
              <div className="mb-4">
                <div className="mt-8 mb-4 border-b pb-6 border-gray">
                  <Heading
                    as="h2"
                    display="h1"
                    title={`Categorii produse ${activeBrand.name}`}
                  />
                </div>
                <div className="flex flex-wrap">
                  {_sortBy(activeBrand.categories, ["name"]).map((categ) => (
                    <div
                      key={categ.id}
                      className="block lg:w-1/5 md:w-1/3 w-1/2 pr-2"
                    >
                      <Link
                        href={`${settings.baseUrl}/${categ.url_key}/cpl/filtru/${attributeCodes.brand}/${activeBrand.slug}/`}
                        passHref
                      >
                        <a className="block text-left text-sm my-1 p-1">
                          <span className="text-black font-medium mr-2 leading-5">
                            {categ.name}
                          </span>
                          <span className="text-gray-light">
                            ({categ.count})
                          </span>
                        </a>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      );
    }

    return <ErrorPage>Aceasta pagina este temporar indisponibila.</ErrorPage>;
  }
}

BrandsPage.pageLayout = "default";

export default connect(null, {
  apiCall,
})(BrandsPage);
